// @flow
export const SP_CNBC_BACKEND_FIELDNAMES = {
  CREDITS_AND_BURSTS_JSON: 'credits_and_bursts_json',
  CREDITS_AND_BURSTS_CONFIG_ARRAY: 'commit_cnbc_inputs',
  CREDITS_AND_BURSTS_YEAR_NUMBER: 'year_number',
  CREDITS_AND_BURSTS_CREDITS_AMOUNT: 'credit_amount',
  CREDITS_AND_BURSTS_BURSTS_AMOUNT: 'burst_amount',
  CREDITS_AND_BURSTS_MAX_CONFIGURABLE_LIMIT: 1000000000,
};
